import React, { useState } from "react";
import { gsap } from "gsap";
import mealone2 from "./assets/mealone2.JPG";

const SvgContainer = () => {
  // State to manage the visibility of the SVG container
  const [isVisible, setIsVisible] = useState(false);

  // Function to handle closing the SVG container
  const closeSvgContainer = () => {
    setIsVisible(false);
    gsap.to(".svg-container", {
      scale: 0.8,
      opacity: 0,
      duration: 0.6,
      display: "none",
    });
  };

  return (
    <div
      onClick={closeSvgContainer}
      className={`svg-container ${isVisible ? "visible" : ""}`}
    >
      <svg
        height="900"
        width="900"
        viewBox="0 0 1728 852"
        fill="none"
        preserveAspectRatio="xMidYMin slice"
      >
        <defs>
          <filter id="displacementFilter">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.03"
              numOctaves="1"
              result="noise"
            />
            <feDisplacementMap
              in="SourceGraphic"
              in2="noise"
              scale="50"
              xChannelSelector="R"
              yChannelSelector="G"
            />
          </filter>
          <mask id="circleMask">
            <circle
              cx="250"
              cy="340"
              r="150"
              fill="white"
              className="displacement"
            />
          </mask>
        </defs>
        <image
          style={{ transform: "translateX(20%)" }}
          width="500"
          height="900"
          href={mealone2}
          // height="100%"
          // width="100%"
          mask="url(#circleMask)"
        />
      </svg>
    </div>
  );
};

export default SvgContainer;
